import FlexibleChart from './FlexibleChart.vue'

export default FlexibleChart
